import React from "react";
import "./styles.css";

const InputAttribute = (props) => {
    const { id, attributeName, value, handleChange } = props;
    return (
        <div className="attribute-values">
            <span>{attributeName}</span>
            <input
                id={id}
                value={value}
                type="number"
                onChange={handleChange}
            />
        </div>
    );
};

export default InputAttribute;
